import { render, staticRenderFns } from "./MiButton.vue?vue&type=template&id=212ed1ad&scoped=true"
import script from "@/components/mi-button/MiButton.ts?vue&type=script&lang=ts&external"
export * from "@/components/mi-button/MiButton.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/mi-button/mi-button.scss?vue&type=style&index=0&id=212ed1ad&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ed1ad",
  null
  
)

export default component.exports